import Vue from 'vue'
import VueRouter from 'vue-router'
import ProviderNotif from '../views/ProviderNotif.vue'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import Gaps from '../views/Gaps.vue'
import Gap from '../views/Gap.vue'
import Discharges from '../views/Discharges.vue'
import Discharge from '../views/Discharge.vue'
import Schedule from '../views/Schedule.vue'
import Appt from '../views/Appt.vue'
import Lab from '../views/Lab.vue'
import LabLogin from '../views/LabLogin.vue'
import LabResult from '../views/LabResult.vue'
import LabResults from '../views/LabResults.vue'
import Call from '../views/Call.vue'
import store from '../store'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/pn/:publicId',
      name: 'providerNotif',
      component: ProviderNotif,
      props: true
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        auth: true
      }
    },
    {
      path: '/gaps',
      name: 'Gaps',
      component: Gaps,
      meta: {
        auth: true
      }
    },
    {
      path: '/gap',
      name: 'Gap',
      component: Gap,
      props: true,
      meta: {
        auth: true
      }
    },
    {
      path: '/discharges',
      name: 'Discharges',
      component: Discharges,
      meta: {
        auth: true
      }
    },
    {
      path: '/discharge',
      name: 'Discharge',
      component: Discharge,
      props: true,
      meta: {
        auth: true
      }
    },
    {
      path: '/schedule',
      name: 'Schedule',
      component: Schedule,
      meta: {
        auth: true
      }
    },
    {
      path: '/appt',
      name: 'Appt',
      component: Appt,
      props: true,
      meta: {
        auth: true
      }
    },
    {
      path: '/lab/:publicId',
      name: 'Lab',
      component: Lab,
      props: true,
      children: [
        {
          path: 'login',
          name: 'LabLogin',
          component: LabLogin,
          props: true,
        },
        {
          path: 'result',
          name: 'LabResult',
          component: LabResult,
          props: true,
        },
        {
          path: 'results',
          name: 'LabResults',
          component: LabResults,
          props: true,
        }
      ]
    },
    {
      path: '/call/:publicId',
      name: 'call',
      component: Call,
      props: true
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    const loggedIn = store.getters['auth/loggedIn'];
    if (loggedIn) {
      next()
      return
    }
    next('/login')
  } else {
    next()
  }
})

export default router
